export default __webpack_public_path__ + "static/media/quizbizz-login.0fdac894.svg";